export enum KfmImageType {
  Kundenunterschrift = 1,
  Dokument = 2,
  Artikel_Vorschaubild = 3,
  Foto_zum_Auftrag = 4,
  Foto_zum_Kontakt = 5,
  Foto_zur_Anlage = 6,
  Monteurunterschrift = 7,
  Foto_zum_Standort = 8,
  MandantData = 9,
  Foto_zum_Formular = 10,
  Foto_zum_Termin = 11,
  OnlineFormularUnterschrift = 12,
  Foto_zur_Rechnung = 13,
}
